import { useRoute, useRouter } from 'vue-router'
import { useMainStore } from 'src/stores/main'
import { useSiteInfoStore } from 'src/stores/site-info'
import { Cookies } from 'src/core/utils/cookies'
import { sendDataToTDS } from 'src/services/tds'
// import afpl from 'src/common/AppsFlyerParseLink'

export function useHandleQueries() {
  const route = useRoute()
  const router = useRouter()

  router.isReady().then(() => {
    handleTokenWebview()
    handleUtm()
    // handleUseSseQuery()
    // checkModals()
  })

  // function checkModals() {
  //   const modalName = route.query.modal
  //   if (!modalName) {
  //     return
  //   }
  //
  //   const MODAL_LIST = {
  //     login: {
  //       auth: false,
  //       guest: true,
  //       action: () => console.log('Login modal opened'),
  //     },
  //     register: {
  //       auth: false,
  //       guest: true,
  //       action: () => console.log('Register modal opened'),
  //     },
  //     profile: {
  //       auth: true,
  //       guest: false,
  //       action: () => console.log('Profile modal opened'),
  //     },
  //     help: {
  //       auth: null,
  //       guest: null,
  //       action: () => console.log('Help modal opened'),
  //     },
  //   }
  //
  //   const handler = MODAL_LIST[modalName]
  //   if (handler) {
  //     if (isAuth.value && handler.auth === false) {
  //       console.warn('Эта модалка не доступна авторизованным пользователям.')
  //       return
  //     }
  //     if (!isAuth.value && handler.guest === false) {
  //       console.warn('Эта модалка не доступна гостям.')
  //       return
  //     }
  //
  //     handler.action()
  //   } else {
  //     console.warn(`Модалка "${modalName}" не найдена.`)
  //   }
  // }

  function handleTokenWebview() {
    const token = route.query.a_ssid
    const app_type = route.query.app_type
    const mb_uuid = route.query.mb_uuid
    const app_id = route.query.app_id

    if (app_type) {
      useMainStore().updateAssid(token)
      useMainStore().updateAppType(app_type)
      useMainStore().updateMbUuid(mb_uuid)
      useMainStore().updateAppId(app_id)
    }
  }

  function handleStag(queriesForSave) {
    queriesForSave.partner = 'stag'
    queriesForSave.pid = route.query.stag.split('_')[0]
    queriesForSave.click_id = route.query.stag.split('_')[1]
  }

  function handleUtm() {
    const UTM_MARKERS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'rich_ref',
      'click_id',
      'partner',
      'pid',
      'modal',
      'sub_id',
      'stag',
    ]
    const query = { ...route.query }
    const urlHasMarker = Object.keys(query).some((item) => UTM_MARKERS.includes(item))

    if (!urlHasMarker) {
      return
    }

    const queriesForSave = Object.keys(query).reduce((acc, key) => {
      if (query[key] === null) {
        return acc
      }
      acc[key] = query[key]

      return acc
    }, {})

    if (query.stag) {
      handleStag(queriesForSave)
    }

    const currentTime = new Date()
    currentTime.setDate(currentTime.getDate() + 30)

    Cookies.set('ref_data', JSON.stringify(queriesForSave), { path: '/', expires: currentTime })
    sendDataToTDS(queriesForSave, route.query, useSiteInfoStore().getUserIp, useSiteInfoStore().getRealRegion)

    // sendDataToDWH(queriesForSave)
  }

  /**
  function sendDataToDWH(queries) {
    afpl.queries = queries
    const affiliateData = afpl.getDataDWH()
    const timestamp = +new Date()

    const payload = {
      pageVisitMessages: [
        {
          userId: store.getters.getUser?.id,
          deviceId: store.getters.getUserIp,
          timestamp,
          geo: store.getters.getRealRegion,
          pageType: 'ELSE',
          affiliateData,
        },
      ],
      datasource: {
        origin: process.env.ENVIRONMENT === 'production' ? 'OC' : 'TEST',
        platform: 'CASINO',
      },
    }

    store.$axios.statistic.send(payload).catch(() => {})
  }
  **/
}
